import moment from 'moment'
import spacetime from 'spacetime'

export const getTimestamp = (time: number) => {
  if (spacetime(time).isSame(spacetime.now(), 'date')) {
    return `Today`
  } else if (spacetime(time).isSame(spacetime.now().subtract(1, 'day'), 'date')) {
    return `Yesterday`
  }

  return `${spacetime(time).format('day')}, ${spacetime(time).format('month')} ${spacetime(
    time
  ).format('date-ordinal')}`
}

export const getTimestampActivityFormat = (time: number, alwaysIncludeTime = false) => {
  const timeOfDay = spacetime(time).unixFmt('h:mm a')

  if (spacetime(time).isSame(spacetime.now(), 'date')) {
    return `Today at ${timeOfDay}`
  }

  if (spacetime(time).isSame(spacetime.now().subtract(1, 'day'), 'date')) {
    return `Yesterday at ${timeOfDay}`
  }

  return spacetime(time).format('numeric-us') + (alwaysIncludeTime ? ` at ${timeOfDay}` : '')
}

export const getTimestampActivityTableFormat = (time: number) => {
  if (spacetime(time).isSame(spacetime.now(), 'date')) {
    return `${spacetime(time).unixFmt('h:mm a')}`
  }

  return spacetime(time).format('numeric-us')
}

const dateNameToAbbriviation = (date: string): string => {
  if (date.includes('second')) {
    return 's'
  } else if (date.includes('minute')) {
    return 'm'
  } else if (date.includes('hour')) {
    return 'h'
  } else if (date.includes('day')) {
    return 'd'
  } else if (date.includes('month')) {
    return 'mo'
  } else if (date.includes('year')) {
    return 'y'
  } else {
    return ''
  }
}

export const timeSinceUpdated = (updatedAt: number): string => {
  const lastUpdated = spacetime(updatedAt)
  const diff = spacetime.now().since(lastUpdated)
  const diffParts = diff.rounded.split(' ')

  if (diffParts.length > 2) {
    return `${diff.rounded.split(' ')[0]}${dateNameToAbbriviation(diff.rounded.split(' ')[1])}`
  } else if (diffParts.length === 1) {
    return diffParts[0]
  } else {
    return ''
  }
}

export const haveTimePassed = (startDate: number, amountOfTime: number, unitOfTime: any) => {
  const currentDate = moment()
  const endDate = moment(startDate).add(amountOfTime, unitOfTime)
  return currentDate.isAfter(endDate)
}

export const humanizedRelativeTime = (timestamp: number): string => {
  return moment.duration(timestamp - moment.now(), 'ms').humanize(true)
}

export const humanizedTime = (timestamp: number): string => moment(timestamp).format('LT')
